import { useState, useEffect } from 'react';
import { formatHeight } from '../../utils/formatters';

export default function HeightDropdown({
  id,
  label,
  value,
  onChange,
  required = false,
  error = '',
  disabled = false
}) {
  const [feet, setFeet] = useState('5');
  const [inches, setInches] = useState('0');

  // Initialize with default height on mount
  useEffect(() => {
    if (!value) {
      onChange(formatHeight('5', '0'));
    }
  }, []);

  const handleFeetChange = (newFeet) => {
    setFeet(newFeet);
    onChange(formatHeight(newFeet, inches));
  };

  const handleInchesChange = (newInches) => {
    setInches(newInches);
    onChange(formatHeight(feet, newInches));
  };

  return (
    <div className="w-full">
      <label className="block text-lg font-semibold text-charcoal mb-2">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <div className="flex gap-4">
        <div className="flex-1">
          <select
            value={feet}
            onChange={(e) => handleFeetChange(e.target.value)}
            required={required}
            disabled={disabled}
            className={`w-full px-4 py-3 text-lg border-2 rounded-button focus:outline-none focus:ring-2 focus:ring-renuvia-gold transition-all ${
              error
                ? 'border-red-500 focus:ring-red-500'
                : 'border-gray-300 focus:border-renuvia-gold'
            } disabled:bg-gray-100 disabled:cursor-not-allowed`}
          >
            {[3, 4, 5, 6, 7, 8].map((f) => (
              <option key={f} value={f}>
                {f} ft
              </option>
            ))}
          </select>
        </div>
        <div className="flex-1">
          <select
            value={inches}
            onChange={(e) => handleInchesChange(e.target.value)}
            required={required}
            disabled={disabled}
            className={`w-full px-4 py-3 text-lg border-2 rounded-button focus:outline-none focus:ring-2 focus:ring-renuvia-gold transition-all ${
              error
                ? 'border-red-500 focus:ring-red-500'
                : 'border-gray-300 focus:border-renuvia-gold'
            } disabled:bg-gray-100 disabled:cursor-not-allowed`}
          >
            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map((i) => (
              <option key={i} value={i}>
                {i} in
              </option>
            ))}
          </select>
        </div>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
}
